import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

function PageLayout({ navItems, children }) {
    function buildOpts(item) {
        const opts = {
            className: `tab-nav__item tab-nav__item--${item.position}`,
            href: item.url,
            key: item.name,
        };
        if (item.active === 'true') {
            opts['data-active'] = 'true';
        }
        return opts;
    }
    return (
        <div>
            <div className="content-header content-header--has-menu">
                <div className="content-header__inner-1">
                    <div className="content-header__inner-2">
                        <div className="flex-container">
                            <h1
                                className="content-header__main-heading
                                content-header__main-heading--offset-right"
                            >
                                <FormattedMessage id="logged_in_h1" />
                            </h1>
                        </div>
                        <div className="content-header__menu">
                            <div className="tab-nav">
                                {navItems.map(item => (
                                    <a {...buildOpts(item)} key={item.name}>
                                        <span className="tab-nav__item__title">{item.name}</span>
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="content-body">
                <div className="content-body__inner-1">
                    <div className="content-body__inner-2">{children}</div>
                </div>
            </div>
        </div>
    );
}

PageLayout.propTypes = {
    children: PropTypes.node.isRequired,
    navItems: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
            position: PropTypes.string.isRequired,
            active: PropTypes.string.isRequired,
        })
    ).isRequired,
};

export default PageLayout;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/PageLayout.jsx